import { BsSearch } from 'react-icons/bs';
import useIntervalTransition from '../../../../hooks/useIntervalTransition';
import NormalInput from '../../../common/NormalInput';
import { Deals } from '../../deals/redux/types';
import DealsGridView from './deals/GridView';
import DealListView from './deals/ListView';
import { DealTabType } from './deals/Tabs';
import { common_container } from './deals/TopCard';

interface DealsViewProps {
    view: 'grid' | 'list';
    title: 'Upcoming' | 'Active';
    dealsList: Deals[];
    activeTab: DealTabType;
    isSelectShow?: boolean;
    filter: string;
    setFilter: (value: string) => void;
    // tags: string[] | undefined;
}

interface DealsViewPropsWithoutSelection {
    view: 'grid' | 'list';
    title: 'Upcoming' | 'Active';
    dealsList: Deals[];
    activeTab: DealTabType;
    isSelectShow?: boolean;
}
type FinalDealsViewProps = DealsViewProps | (DealsViewPropsWithoutSelection & Partial<DealsViewProps>);

function DealsView({
    view,
    dealsList,
    title,
    activeTab,
    isSelectShow = true,
    filter,
    setFilter,
}: // tags = "",
FinalDealsViewProps) {
    const dealListCount = useIntervalTransition(dealsList.length, 100);
    return (
        <>
            <div className={`${common_container}`}>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 md:gap-4">
                    <div className="col-span-1 flex items-center justify-between pb-2 flex-col md:flex-row">
                        <div className="flex w-full justify-start items-center">
                            <p className="font-[WorkSans-Semibold] text-[22px] lg:text-[32px] text-[#20222B] font-semibold uppercase">
                                {activeTab !== 'closedDeals' ? title : 'Recently Closed'}
                            </p>
                            <div className="bg-[#142C53] py-1 px-2 mx-8">
                                <p className="font-[WorkSans-Semibold] text-xs text-white font-bold">{dealListCount}</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-span-1 hidden lg:block"></div>
                    {isSelectShow ? (
                        <div className="col-span-1 flex w-full md:w-auto pb-2">
                            {/* <div className="flex w-full py-2 md:w-auto md:py-0">
                                <Select
                                    mode="multiple"
                                    suffixIcon={<BsSearch size={'1.3rem'} />}
                                    className="deals_search w-full"
                                    showSearch={true}
                                    showArrow
                                    value={filter}
                                    onChange={(value) => {
                                        setFilter && setFilter(value);
                                    }}
                                    options={(tags ?? [])?.map((t) => {
                                        return { label: t, value: t };
                                    })}
                                />
                            </div> */}
                            <div className="w-full">
                                <NormalInput
                                    value={filter}
                                    name="search"
                                    onChange={(e: { name: string; value?: number | string }) => {
                                        const { value } = e;
                                        setFilter && setFilter(String(value || ''));
                                    }}
                                    placeholder="Search"
                                    className="w-full bg-white deals_search"
                                    // bordered={false}
                                    suffix={<BsSearch color='#D9D9D9' size={'1.3rem'} />}
                                />
                            </div>
                        </div>
                    ) : null}
                </div>
            </div>
            {view === 'grid' && (
                <div className={`${common_container} pb-20`}>
                    <DealsGridView list={dealsList} />
                </div>
            )}

            {view === 'list' && <DealListView list={dealsList} />}
        </>
    );
}

export default DealsView;
